<template>
  <div style="max-width: 900px">
    <ValidationObserver ref="form">
      <form>
<!--        <h1>活動資料</h1>-->
<!--        <div class="form-group row">-->
<!--          <label for="" class="col-sm-3"><span/> 活動名稱 <span class="require" v-if="formDataValidate.Name" >*</span></label>-->
<!--          <div class="col-sm-9">-->
<!--            <validation-provider :rules="formDataValidate.Name" v-slot="{ errors }" name="姓名">-->
<!--              <input type="text" class="form-control" placeholder="" v-model="formData.Name" >-->
<!--              <span>{{ errors[0] }}</span>-->
<!--            </validation-provider>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="form-group row">-->
<!--          <label for="" class="col-sm-3"><span/> 備註 <span class="require" v-if="formDataValidate.Memo" >*</span></label>-->
<!--          <div class="col-sm-9">-->
<!--            <validation-provider :rules="formDataValidate.Memo" v-slot="{ errors }" name="date">-->
<!--              <input type="text" class="form-control" placeholder="" v-model="formData.Memo" >-->
<!--              <span>{{ errors[0] }}</span>-->
<!--            </validation-provider>-->
<!--          </div>-->
<!--        </div>-->

        <h1>場次</h1>
        <table class="table table-hover" id="tblMain">
          <thead class="thead-light">
          <tr>
            <th>場次名稱</th>
            <th>類型</th>
            <th>是否已報名</th>
            <th>是否報到</th>
            <th>報到時回覆</th>
            <!--            <th>備註</th>-->
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in formData.EventItems" :key="index">
            <td width="200px">
              {{item.Name}}
            </td>
            <td width="200px">
              <div v-if="item.Type===CheckIn_EventItemType_Open">
                開放型(不需預先報名)
              </div>
              <div v-else-if="item.Type===CheckIn_EventItemType_NeedReg">
                需先報名
              </div>
              <div v-else>
                XX:{{item.Type}}
              </div>
            </td>
            <td>
              <label class="radio-inline"><input type="radio" :name="'r1'+item.Name" :value="'1'" v-model="item.IsJoin">是</label>
              <label class="radio-inline"><input type="radio" :name="'r1'+item.Name" :value="'0'" v-model="item.IsJoin">否</label>
            </td>
            <td>
              <label class="radio-inline"><input type="radio" :name="'r2'+item.Name" :value="'1'" v-model="item.IsCheckIn">是</label>
              <label class="radio-inline"><input type="radio" :name="'r2'+item.Name" :value="'0'" v-model="item.IsCheckIn">否</label>
              <br>
<!--              簽到者:{{item.CheckInExecBy}}-->
            </td>
            <td>
              <div v-if="item.Question1">
              問題1 {{ item.Question1}} <br>
              報到回覆:  <MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr>
              </div>
              <hr>
              <div v-if="item.Question2">
              問題2 {{ item.Question2}} <br>
              報到回覆:  <MyRadioWithTokenStr v-model="item.Question2Answer" :option-token-str="item.Question2Options" token-str=","></MyRadioWithTokenStr>
              </div>
              <hr>
              <div v-if="item.Question3">
              問題3 {{item.Question3}} <br>
              報到回覆:  <MyRadioWithTokenStr v-model="item.Question3Answer" :option-token-str="item.Question3Options" token-str=","></MyRadioWithTokenStr>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
/**
 <UIEventItems :member="formData"  :event-system-id="EventSystemId"></UIEventItems>
 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg} from "@/views/checkInAdmin/js/checkInDeclare";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import MyRadioWithTokenStr from "@/views/taylorAdmin/component/MyRadioWithTokenStr";

export default {
  components: {MyRadioWithTokenStr},
  props: ['Member','EventSystemId'], //tag  postTitle="hi"  data this.postTitle
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      // type: "",
      formData: {
        Name: "",
        Memo:"",
        EventItems:[],
      },
      formDataValidate: {
        Name: "required",
        Memo:"",
      },
      // formDataJoin:[
      //   {
      //     EventSystemId:"",
      //     EventItemSystemId:"",
      //     Question1Answer:"",
      //     Question1Answer:"",
      //     Question1Answer:"",
      //   }
      // ]
      MemberDataFormSave:{},
    };
  },
  methods: {
    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);

      if (this.EventSystemId){
        apiCheckIn.api_Event_Get(this.EventSystemId).then((data)=>{
          that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,this.formData);

          that.formData.EventItems.forEach((item)=>{
            item.IsJoin=false;//虛擬欄位:預設沒報名
            item.IsCheckIn=false;
            item.CheckInExecBy="";
            item.Question1Answer="";
            item.Question2Answer="";
            item.Question3Answer="";
          });

          that.formData.EventItems.forEach((item)=>{

            let eventItem=that.Member.EventItems.find(s => s.EventItemSystemId===item.SystemId);
            if (eventItem){
              item.IsJoin=eventItem.IsJoin;
              item.IsCheckIn=eventItem.IsCheckIn;
              item.CheckInExecBy=eventItem.CheckInExecBy;
              item.Question1Answer=eventItem.Question1Answer;
              item.Question2Answer=eventItem.Question2Answer;
              item.Question3Answer=eventItem.Question3Answer;
            }
          });
          //
          // that.Member.EventItems.forEach((item)=>{
          //
          //   let eventItem=that.formData.EventItems.find(s => s.SystemId===item.EventItemSystemId);
          //
          //   if (eventItem){
          //     item.IsJoin=eventItem.IsJoin;
          //     item.IsCheckIn=eventItem.IsCheckIn;
          //     item.CheckInExecBy=eventItem.CheckInExecBy;
          //     item.Question1Answer=eventItem.Question1Answer;
          //     item.Question2Answer=eventItem.Question2Answer;
          //     item.Question3Answer=eventItem.Question3Answer;
          //   }
          // });

          util.HideLoading(loader);
        });
      }else{
        util.HideLoading(loader);
      }
    },
    getMemberEventItemsDataForSave(){
      let eventItemsReturn=[];

      this.formData.EventItems.forEach((item)=>{
        let eventItem={
          EventSystemId:this.EventSystemId,
          EventItemSystemId:item.SystemId,
          IsJoin:item.IsJoin,
          IsCheckIn:item.IsCheckIn,
          CheckInExecBy:item.CheckInExecBy,
          Question1Answer:item.Question1Answer,
          Question2Answer:item.Question2Answer,
          Question3Answer:item.Question3Answer,
        }

        eventItemsReturn.push(eventItem);
      })

      return eventItemsReturn;
    }
  },
  mounted() {
    this.getItem()
  },
}
</script>

<style scoped>

</style>
